import {
    getRestlaufzeitFromSails,
    getSessionStorageItemJson,
} from '@vfde-sails/storage';
import { SAILS_BNT_STORAGE } from '@vfde-sails/constants';
import { SailsDeviceDetailsStorage } from '../../../interfaces/storage';

/**
 * Get Restlaufzeit from storage
 * @returns boolean
 */
export const getRestlaufzeit = (): boolean => {
    const storage = getSessionStorageItemJson<SailsDeviceDetailsStorage>(SAILS_BNT_STORAGE) || {} as SailsDeviceDetailsStorage;

    return getRestlaufzeitFromSails(storage);
};
